
import PublicationPage from '@/components/Details/PublicationPage.vue';
import FieldOfStudyPage from '@/components/Details/FieldOfStudyPage.vue';
import AuthorPage from '@/components/Details/AuthorPage.vue';
import AffiliationPage from '@/components/Details/AffiliationPage.vue';
import { defineComponent, PropType, ref, watch } from 'vue';
import { SearchResponse } from '@/models/Search';
import { XIcon, ExclamationCircleIcon } from '@heroicons/vue/solid';
import { DetailType } from '@/models/Details';

export default defineComponent({
  // Container for DetailPages for Search(publications, authors, ...)
  // TODO for state in menu/details the pages need to be reachable by URL
  name: 'Details',
  components: {
    PublicationPage,
    AuthorPage,
    AffiliationPage,
    FieldOfStudyPage,
    XIcon,
    ExclamationCircleIcon,
  },
  props: {
    searchres: {
      type: Object as PropType<SearchResponse>,
      required: false,
    },
    content: {
      type: Object as PropType<{
        id: number;
        type: DetailType;
      }>,
      required: false,
    },
  },
  setup(props) {
    // provides 'Loading' Element while the content of the component (PublicationPage, AuthorPage... is built)
    const isLoading = ref(true);
    const isPublication = ref(false);
    const isAuthor = ref(false);
    const isAffiliation = ref(false);
    const isFieldOfStudy = ref(false);
    const hasFetchFailed = ref(false);
    const currentId = ref(props.content?.id);
    const currentSearchres = ref(props.searchres);
    if (
      props &&
      (props.searchres != undefined ||
        (props.content && props.content.type == DetailType.PUBLICATION))
    ) {
      isPublication.value = true;
    }
    if (props.content && props.content.type == DetailType.AUTHOR) {
      isAuthor.value = true;
    }
    if (!props.content && !props.searchres) {
      isLoading.value = false;
      hasFetchFailed.value = true;
    }
    watch(
      () => props.searchres,
      (newVal, oldVal) => {
        if (newVal != oldVal) {
          isPublication.value = true;
          currentId.value = undefined;
          currentSearchres.value = newVal;
        }
        if (!newVal) hasFetchFailed.value = true;
      }
    );
    const loading = () => {
      isLoading.value = true;
      hasFetchFailed.value = false;
    };
    const stopLoading = () => {
      isLoading.value = false;
    };
    const fetchFailed = () => {
      isLoading.value = false;
      hasFetchFailed.value = true;
    };
    const viewNewDetail = (id: number, type: DetailType) => {
      console.log('viewNewDetail');
      if (type == DetailType.PUBLICATION) {
        currentId.value = id;
        currentSearchres.value = undefined;
        isPublication.value = true;
        isAuthor.value = false;
        isFieldOfStudy.value = false;
        isAffiliation.value = false;
      } else if (type == DetailType.AUTHOR) {
        currentId.value = id;
        isPublication.value = false;
        isAffiliation.value = false;
        isFieldOfStudy.value = false;
        isAuthor.value = true;
      } else if (type == DetailType.AFFILIATION) {
        currentId.value = id;
        isPublication.value = false;
        isAuthor.value = false;
        isFieldOfStudy.value = false;
        isAffiliation.value = true;
      } else if (type == DetailType.FIELDOFSTUDY) {
        console.log('view Field of Study');
        currentId.value = id;
        isPublication.value = false;
        isAuthor.value = false;
        isAffiliation.value = false;
        isFieldOfStudy.value = true;
      }
    };
    return {
      currentId,
      currentSearchres,
      isLoading,
      isPublication,
      isAuthor,
      isAffiliation,
      isFieldOfStudy,
      loading,
      stopLoading,
      fetchFailed,
      hasFetchFailed,
      viewNewDetail,
    };
  },
});
